import React from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

import {getContentType} from 'app/utils/content-type';

import {ContentType} from 'sweet-types';

const StyledContainerDiv = styled.div`
  font-size: 90%;
  text-transform: uppercase;
  font-weight: bold;
  color: ${colors.mediumGray};
`;
type Props = {
  contentType: ContentType;
  statusContent?: React.ReactElement | null;
};

const MetaContentTypeName = ({
  contentType,
  statusContent,
  ...other
}: Props): JSX.Element => {
  const ctData = getContentType(contentType);
  return (
    <div className="row">
      <div className="col d-flex align-items-center">
        <StyledContainerDiv {...other}>
          <i className={`fa ${ctData.icon}`} /> {ctData.name}
        </StyledContainerDiv>
      </div>
      {statusContent != null ? (
        <div className="col-6 col-sm-4 col-md-3 col-xl-2 justify-content-end text-muted d-flex align-items-center">
          {statusContent}
        </div>
      ) : null}
    </div>
  );
};

export default MetaContentTypeName;
